<template>
  <div class="map-item-filter">
    <div
      class="col-sm-12 nopads vehicle-list"
    >
      <span
        class="vehicle-list-title"
        @click.stop="toggleList"
      >
        {{ $t('map_tooltips.infra_data') }}
      </span>
      <div
        class="vehicle-list-caret"
        :class="{ caret_open: listOpen }"
        @click.stop="toggleList"
      >
        <font-awesome-icon icon="caret-down" />
      </div>
      <div
        class="col-sm-12 nopads map-accordion-content"
        :class="{ 'map-accordion-open': listOpen }"
      >
        <div :class="{ 'm-2': listOpen }">
          <div
            class="container map-select-item pt-0"
          >
            <div class="row nopads pb-2">
              <div class="col-sm-6 form-check text-light" v-for="option in filters" :key="option.value">
                  <input
                      class="form-check-input"
                      type="checkbox"
                      :id="'checkbox-' + option.value"
                      :value="option.value"
                      v-model="selectedTypes"
                  />
                  <label
                      class="form-check-label ellipsize"
                      :for="'checkbox-' + option.value"
                  >
                      {{ option.text }}
                  </label>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {mapHelper} from "../mixins/MapMixin";
import {restApi} from '../mixins/RestApiMixin'

export default {
    name: "InfraMapFilter",
    mixins: [restApi, mapHelper],
    data() {
        return {
            isOpen: true,
            listOpen: false,
            allSelected: false,
            multiselectOpen: false,
            selectedTypes: []
        };
    },
    watch: {
        selectedTypes(val) {
            this.$emit('typesSelected', val)
        }
    },
    computed: {
        filters() {
            return [
                {
                    text: this.$t("storm_sewers.sewers"),
                    value: this.SEWERS,
                    selected: false
                },
                {
                    text: this.$t("storm_sewers.drains"),
                    value: this.DRAINS,
                    selected: false
                },
                {
                    text: this.$t("menu.street_lights"),
                    value: this.STREET_LIGHT,
                    selected: false
                },
                {
                    text: this.$t("menu.traffic_signs"),
                    value: this.TRAFFIC_SIGN,
                    selected: false
                },
                {
                    text: this.$t("menu.bridges"),
                    value: this.BRIDGE,
                    selected: false
                },
                {
                    text: this.$t("menu.mixed_waste_bins"),
                    value: this.MIXED_WASTE_BINS,
                    selected: false

                }
            ]
        }
    },
    methods: {
        toggleList: function () {
            this.listOpen = !this.listOpen
        },
        toggleFilter(filter, value) {
            const exists = this.selectedTypes.includes(filter);
            if (value && !exists) {
                this.selectedTypes.push(filter);
            } else if (!value && exists) {
                this.selectedTypes = this.selectedTypes.filter(item => item !== filter);
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.multiselect-expand {
    background: #FAA633;
    height: 300px;
}
</style>
